<template>
  <gj-modal
      v-bind="$attrs"
      v-on="$listeners"
      class="delete-prompt"
      :confirmLoading="confirmLoading"
      :visible.sync="modalVisible"
      size="normal"
      @cancel="cancel"
      @confirm="confirm"
      @close="cancel">
    <template #header>
      <span>确定移除“新手任务”入口</span>
    </template>
    <template #content>
      <p class="prompt-title">您目前未完成所有新手任务，确定要将“新手任务”入口从页面右下角移除吗？</p>
      <div class="prompt">后续如果需要继续完成新手任务，可在页面左上角的个人中心进入</div>
    </template>
  </gj-modal>
</template>

<script>
import {modalMixIn} from "@/minxins";
import {deletePrompt} from "@/api/user";

export default {
  name: "delete-prompt",
  mixins: [modalMixIn],
  data() {
    return {
      confirmLoading: false,
      newUrl: window.location.origin + '/guide-video?code=MARKET'
    }
  },
  methods: {
    confirm() {
      this.confirmLoading = true;
      deletePrompt().then((res) => {
        this.$emit('successDelete');
      }).complete(() => {
        this.confirmLoading = false;
      })
    },
    cancel() {
      this.$emit('closeOpen');
      this.$gjDestroy();
    }
  }
}
</script>

<style scoped lang="scss">
.prompt-title {
  font-size: 14px;
  line-height: 20px;
}

.prompt {
  line-height: 20px;
  font-size: 12px;

  .prompt-operator {
    color: #1F6EEF;
    cursor: pointer
  }
}
.delete-prompt {
  /deep/ .v-modal {
    margin-top: 0 !important;
    margin-left: 0 !important;
    opacity: 0.8 !important;
  }

  /deep/ .gj-modal--vertical{
    margin-left: 0;
  }
}

</style>
